import { createFromIconfontCN } from '@ant-design/icons';

export default createFromIconfontCN({
    scriptUrl: "/iconfont/font_4975128_s30j631phon.js?v=20260424"
})
